
import { useTranslation } from 'react-i18next';

export default function LendingComparisonSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block bg-yellow-500 text-gray-900 px-6 py-2 rounded-full font-bold text-lg mb-6">
            {t('lending.comparison.badge')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.comparison.title')}
          </h2>
        </div>

        {/* 比較テーブル */}
        <div className="mb-12 bg-gray-800 rounded-xl overflow-hidden border border-gray-700">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[500px]">
              <thead className="bg-teal-900">
                <tr>
                  <th className="py-3 md:py-4 px-3 md:px-6 text-left text-white font-semibold text-sm md:text-base">{t('lending.comparison.table.feature')}</th>
                  <th className="py-3 md:py-4 px-3 md:px-6 text-center text-white font-semibold text-sm md:text-base">{t('lending.comparison.table.mycoin')}</th>
                  <th className="py-3 md:py-4 px-3 md:px-6 text-center text-white font-semibold text-sm md:text-base">{t('lending.comparison.table.others')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.rate')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">13.2%</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">3-8%</td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.fee')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">
                    <i className="ri-check-line text-xl md:text-2xl"></i> {t('lending.comparison.table.free')}
                  </td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-red-400 text-sm md:text-base">
                    <i className="ri-close-line text-xl md:text-2xl"></i> {t('lending.comparison.table.charged')}
                  </td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.minAmount')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">{t('lending.comparison.table.noMin')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">{t('lending.comparison.table.hasMin')}</td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.lockPeriod')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">{t('lending.comparison.table.noLock')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">{t('lending.comparison.table.hasLock')}</td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.currencies')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">21{t('lending.comparison.table.types')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">5-10{t('lending.comparison.table.types')}</td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.support')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">
                    <i className="ri-check-line text-xl md:text-2xl"></i> 24/7
                  </td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">{t('lending.comparison.table.limited')}</td>
                </tr>
                <tr className="hover:bg-gray-750 transition-colors">
                  <td className="py-3 md:py-4 px-3 md:px-6 text-gray-300 font-semibold text-sm md:text-base">{t('lending.comparison.table.withdrawal')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-green-400 text-base md:text-lg font-bold">{t('lending.comparison.table.anytime')}</td>
                  <td className="py-3 md:py-4 px-3 md:px-6 text-center text-gray-400 text-sm md:text-base">{t('lending.comparison.table.restricted')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-gray-800 rounded-2xl p-6 md:p-8 border border-gray-700">
          <h3 className="text-xl md:text-2xl font-bold text-yellow-400 mb-6 flex items-center">
            <i className="ri-book-open-line text-2xl md:text-3xl mr-3"></i>
            {t('lending.comparison.terms.title')}
          </h3>
          
          <div className="space-y-6">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-yellow-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-xl text-yellow-400"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-white">{t('lending.comparison.terms.period.title')}</h4>
              </div>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed pl-0 md:pl-11">
                {t('lending.comparison.terms.period.desc')}
              </p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-yellow-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-refresh-line text-xl text-yellow-400"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-white">{t('lending.comparison.terms.reinvest.title')}</h4>
              </div>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed pl-0 md:pl-11">
                {t('lending.comparison.terms.reinvest.desc')}
              </p>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-yellow-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-hand-coin-line text-xl text-yellow-400"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-white">{t('lending.comparison.terms.fees.title')}</h4>
              </div>
              <div className="text-sm md:text-base text-gray-300 leading-relaxed pl-0 md:pl-11 space-y-2">
                <p><strong className="text-yellow-400">{t('lending.comparison.terms.fees.return')}</strong><br />
                {t('lending.comparison.terms.fees.returnDesc')}</p>
                <p><strong className="text-yellow-400">{t('lending.comparison.terms.fees.transfer')}</strong><br />
                {t('lending.comparison.terms.fees.transferDesc')}</p>
                <p className="text-green-400 font-bold">{t('lending.comparison.terms.fees.noFee')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
